import { render } from "./AddModalCorrectionRequest.vue?vue&type=template&id=108be808&ts=true"
import script from "./AddModalCorrectionRequest.vue?vue&type=script&lang=ts"
export * from "./AddModalCorrectionRequest.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__